var map = {
  "./desktop/index.js": [
    "49656",
    "76225",
    "62815",
    "61301",
    "47387",
    "3199",
    "50437",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "42747",
    "84397"
  ],
  "./desktop/index": [
    "49656",
    "76225",
    "62815",
    "61301",
    "47387",
    "3199",
    "50437",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "42747",
    "84397"
  ],
  "./mobile": [
    "21126",
    "76225",
    "61301",
    "8450",
    "47387",
    "3199",
    "50437",
    "6937",
    "38154",
    "17189",
    "42747",
    "72775"
  ],
  "./desktop": [
    "49656",
    "76225",
    "62815",
    "61301",
    "47387",
    "3199",
    "50437",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "42747",
    "84397"
  ],
  "./desktop/": [
    "49656",
    "76225",
    "62815",
    "61301",
    "47387",
    "3199",
    "50437",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "42747",
    "84397"
  ],
  "./mobile/": [
    "21126",
    "76225",
    "61301",
    "8450",
    "47387",
    "3199",
    "50437",
    "6937",
    "38154",
    "17189",
    "42747",
    "72775"
  ],
  "./mobile/index": [
    "21126",
    "76225",
    "61301",
    "8450",
    "47387",
    "3199",
    "50437",
    "6937",
    "38154",
    "17189",
    "42747",
    "72775"
  ],
  "./mobile/index.js": [
    "21126",
    "76225",
    "61301",
    "8450",
    "47387",
    "3199",
    "50437",
    "6937",
    "38154",
    "17189",
    "42747",
    "72775"
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
    return __webpack_require__(id);
  });
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 60621;
module.exports = __rspack_async_context;
